import { combineReducers } from "redux";

import ThemeOptions from "./ThemeOptions";
import AjaxReducer from "./ajax";
import ProfileReducer from "./profile";

export default combineReducers({
	AjaxReducer,
	ProfileReducer,
	ThemeOptions,
});
